/**
 * Enum defining the available social login options (may be limited by team)
 */
export enum SocialLoginOption {
  GOOGLE = "google",
  /** Shopify new customer accounts, signed in through the app proxy */
  SHOPIFY = "shopify",
}
